import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Stack, 
  Grid, 
  Divider, 
  Alert, 
  useTheme 
} from '@mui/material';
import { TopicCardProps } from '../types';
import SubtopicItem from './SubtopicItem';

const TopicCard: React.FC<TopicCardProps> = ({ topic, topicIndex }) => {
  const theme = useTheme();
  
  return (
    <Grid item xs={12} md={6} key={topicIndex}>
      <Card variant="outlined" sx={{ 
        height: '100%', 
        mb: { xs: 0, md: 0 },
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: 3,
          borderColor: theme.palette.primary.main,
          transform: 'translateY(-4px)'
        }
      }}>
        <CardContent>
          <Typography 
            variant="h6" 
            sx={{ 
              color: theme.palette.primary.main,
              fontWeight: 'bold'
            }}
          >
            {/* Handle case where topic name might be a number */}
            {typeof topic.name === 'string' && topic.name.match(/^\d+$/) 
              ? `Topic ${parseInt(topic.name) + 1}` 
              : topic.name}
          </Typography>
          <Divider sx={{ my: 2 }} />
          
          {(topic.subtopics || []).length > 0 ? (
            <Stack spacing={3}>
              {topic.subtopics.map((subtopic, subtopicIndex) => (
                <SubtopicItem 
                  key={subtopicIndex} 
                  subtopic={subtopic} 
                />
              ))}
            </Stack>
          ) : (
            <Alert severity="info" sx={{ mt: 2 }}>
              No subtopics found for this topic
            </Alert>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TopicCard;
